import { MutableRefObject, useEffect } from "react";

/**
 * Resets the booking flow's step scroll container to the top whenever the
 * step changes. The flows render all steps inside one persistent StepWrapper
 * (overflowY: auto) within a fixed full-screen dialog, so without this the
 * next step inherits the previous step's scroll offset and appears
 * mid-screen. A window-level scrollTo would be a no-op here — the wrapper,
 * not the window, is the scrolling element.
 */
export const useScrollToTopOnStepChange = (
  stepWrapperRef: MutableRefObject<HTMLElement | undefined>,
  step: number
) => {
  useEffect(() => {
    stepWrapperRef.current?.scrollTo({ top: 0 });
  }, [stepWrapperRef, step]);
};
